import '../../Styles/sponsorshipExamplesOverview.scss';

await import('jquery-match-height');

await import(/* webpackChunkName: "ajax" */ 'Feature/Common/code/Scripts/Common/ajax');
await import(/* webpackChunkName: "parents" */ 'Feature/Common/code/Scripts/Common/parents');

window.am = window.am || {};

window.am.sponsorshipListView = new function () {
    var that = this;
    const sponsorshipListViewApiUrl = "/api/sitecore/SponsorshipExamples/RenderSponsorshipList";

    that.initFilters = function (filterContainer, pageId, submitButtons) {

        var filters = filterContainer.querySelectorAll('input[type="checkbox"]');

        if (!filters || filters.length == 0) {
            return;
        }

        for (let i = 0; i < filters.length; i++) {
            let filter = filters[i];

            filter.addEventListener('click', function () {
                /* reload each content section based on the submit button. */
                for (let i = 0; i < submitButtons.length; i++) {
                    loadSponsorshipExampleContent(submitButtons[i], pageId, filterContainer, true);
                }
            });
        }
    }

    that.init = function () {

        var overviews = document.querySelectorAll('.sponsorship-examples-overview');

        if (!overviews || overviews.length == 0) {
            return;
        }

        overviews.forEach(function (overview) {
            var submitButtons = overview.querySelectorAll('.sponsorship-list-view-button button.link-button');

            var pageId = overview.getAttribute('data-context-id');
            var filterContainer = overview.querySelector('.sponsorship-example-filters');

            submitButtons.forEach(function (submitButton) {
                submitButton.addEventListener('click', function (event) {
                    loadSponsorshipExampleContent(event.target, pageId, filterContainer);
                });
            });

            if (filterContainer) {
                that.initFilters(filterContainer, pageId, submitButtons);
            }

            $(overview).find('img.lazyload').on('load', function () {
                matchHeight(overview);
            });
        });
    }

    function loadSponsorshipExampleContent(submitButton, pageId, filterContainer, reset) {

        submitButton.setAttribute('disabled', '');
        toggleFiltersState(filterContainer, true);

        var isAdvanced = submitButton.getAttribute('data-is-advanced').toLowerCase() == "true";
        var totalResults = parseInt(submitButton.getAttribute('data-total-results'));
        var currentPage = parseInt(submitButton.getAttribute('data-current-page'));
        var take = parseInt(submitButton.getAttribute('data-take'));
        var filterIdQuery = getFilterQuery(filterContainer);

        if (reset && reset == true) {
            currentPage = 0;
        }

        var shouldReset = (reset && reset == true);

        if (isNaN(take)) {
            take = 10;
        }

        if (isNaN(currentPage)) {
            currentPage = 0;
        }

        const apiUrlNextPage = "".concat(sponsorshipListViewApiUrl, "?skip=", currentPage * take, "&take=", take, "&isAdvanced=", isAdvanced, filterIdQuery, '&contextId=', pageId);

        window.am.ajax.sendRequest(apiUrlNextPage,
            'GET',
            function getPageSuccessfulCallback(result) {
                var html = result.html;
                var wrapper = submitButton.parent('.list-wrapper');
                var list = wrapper.querySelector('.sponsorship-list');

                if (!html) {
                    wrapper.classList.add('hidden');
                }
                else {
                    if (shouldReset) {
                        totalResults = result.totalResults;
                        list.innerHTML = html;
                        submitButton.setAttribute('data-total-results', result.totalResults);
                    }
                    else {
                        list.insertAdjacentHTML('beforeend', html);
                    }

                    matchHeight(list);
                }

                submitButton.setAttribute('data-current-page', currentPage + 1);

                if (isNaN(totalResults) || ((currentPage + 1) * take) >= totalResults) {
                    submitButton.classList.add('hidden');
                }
                else {
                    submitButton.classList.remove('hidden');
                }

                submitButton.removeAttribute('disabled');

                toggleFiltersState(filterContainer, false);
            }, null);
    }

    function getFilterQuery(filterContainer) {
        var filterIdQuery = "";

        if (filterContainer) {
            var checkedFilters = filterContainer.querySelectorAll('input[type="checkbox"]:checked');

            if (checkedFilters)
            {
                checkedFilters.forEach(function (filter)
                {
                    filterIdQuery = filterIdQuery + "&filterIds=" + filter.value;  
                });               
            }
        }

        return filterIdQuery;
    }

    function toggleFiltersState(filterContainer, disabled) {

        var shouldDisabled = (disabled && disabled == true);

        if (!filterContainer) {
            return;
        }

        var cbs = filterContainer.querySelectorAll('input[type="checkbox"]');

        for (var i = 0; i < cbs.length; i++) {

            if (shouldDisabled) {
                cbs[i].setAttribute('disabled', '');
            }
            else {
                cbs[i].removeAttribute('disabled');
            }
        }
    }

    /**
     * save the current user position because matchheight changes the position :/
     * @param {object} containerElement
     */
    function matchHeight(containerElement) {
        var currentPosition = window.pageYOffset;
        $(containerElement.querySelectorAll('.js-equalHeight')).matchHeight();

        window.scrollTo(0, currentPosition);
    }
}

window.am.sponsorshipListView.init()